import { LocalizedValueModel } from '../../models';
import { FilterByField } from '../field-filter.model';

export interface PostFieldAttribute {
  name: string;
  label: LocalizedValueModel;
  required: boolean;
  acceptedFieldsCriteria: FilterByField[];
  preferredComponent?: string;
}
export class TimelineCategoryPresenterModel {
  id: string;
  title: LocalizedValueModel;
  attributes: Array<PostFieldAttribute>;
  specificationVersion: number;
}
